import "./navbar.css";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import FullscreenExitOutlinedIcon from "@mui/icons-material/FullscreenExitOutlined";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import CloseIcon from '@mui/icons-material/Close';
import ListOutlinedIcon from "@mui/icons-material/ListOutlined";
import { Link } from "react-router-dom";
// import { DarkModeContext } from "../../context/darkModeContext";
// import { useContext } from "react";

const Navbar = ({handleSideBar, showSideBar}) => {
  //   const { dispatch } = useContext(DarkModeContext);

  

  return (
    <div className="h-[50px] border flex flex-row items-center justify-end fixed top-0 left-0 w-[100vw] bg-white">
      <div className="hidden md:flex flex-row w-[100%] p-[20px] items-center justify-end gap-[1rem]">
        <div className="search flex items-center border border-gray-300 p-[3px]">
          <input type="text" placeholder="Search..." />
          <SearchOutlinedIcon />
        </div>
        <div className="flex flex-row items-center gap-[1.5rem]">
          <div className="item">
            <LanguageOutlinedIcon className="icon" />
            English
          </div>
          <div className="item">
            <DarkModeOutlinedIcon
              className="icon"
              //   onClick={() => dispatch({ type: "TOGGLE" })}
            />
          </div>
          <div className="item">
            <FullscreenExitOutlinedIcon className="icon" />
          </div>
          <div className="item">
            <NotificationsNoneOutlinedIcon className="icon" />
            <div className="counter w-[15px] h-[15px] bg-red-500 rounded-full flex items-center justify-center text-[10px] absolute ml-[1rem] top-[5px]  font-bold text-white">1</div>
          </div>
          <div className="item">
            <ChatBubbleOutlineOutlinedIcon className="icon" />
            <div className="counter w-[15px] h-[15px] bg-red-500 rounded-full flex items-center justify-center text-[10px] absolute ml-[1rem] top-[5px]  font-bold text-white">2</div>
          </div>
          <div className="item">
            <ListOutlinedIcon className="icon" />
          </div>
          <div className="item flex gap-[20px]">
            <img
              src="https://images.pexels.com/photos/941693/pexels-photo-941693.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=500"
              alt=""
              className="avatar w-10 h-10 rounded-full"
            />
          </div>
        </div>
      </div>

      <div className="flex flex-row justify-between w-[100%] px-[1rem] md:hidden bg-white">
      <div className="">
        <Link to="/" style={{ textDecoration: "none" }}>
          <span className="text-[20px] font-bold text-[#FF6709]">Bits</span>
          <span className="text-[20px] font-bold text-black">hub</span>
        </Link>
      </div>
      {
        !showSideBar ? <ListOutlinedIcon onClick={handleSideBar}/> : <CloseIcon onClick={handleSideBar}/>
      }
      
      </div>

    </div>
  );
};

export default Navbar;
